import { z } from "zod";

/// URL search-params for `/$slug/one-on-ones/with/$userId`, the relationship
/// history view. Filters are client-side over the loaded window; `status`
/// narrows to a lifecycle slice, `q` text-matches title / notes.
export const ONE_ON_ONE_WITH_STATUSES = ["all", "completed", "cancelled"] as const;
export type OneOnOneWithStatus = (typeof ONE_ON_ONE_WITH_STATUSES)[number];

export const oneOnOneWithRouteSearchSchema = z
  .object({
    status: z.enum(ONE_ON_ONE_WITH_STATUSES).catch("all").default("all"),
    q: z.string().optional(),
    /// Display-name hint carried from the link source so the header renders
    /// before the first page loads.
    name: z.string().optional(),
  })
  .strict();
export type OneOnOneWithRouteSearch = z.infer<typeof oneOnOneWithRouteSearchSchema>;
